import { Sidebar } from "@/components/layout/sidebar";

interface AppLayoutProps {
	children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
	return (
		<div className="h-screen overflow-hidden bg-slate-100 md:flex">
			<Sidebar />
			<div className="flex min-w-0 flex-1 flex-col overflow-hidden">
				<main className="flex-1 overflow-y-auto p-4 md:p-6">{children}</main>
			</div>
		</div>
	);
}
